import { Injectable } from '@angular/core';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { IResource } from '@common/interfaces/resource';
import { ResourceStore } from './resource.store';
import { ResourceQuery } from './resource.query';

@Injectable({
  providedIn: 'root'
})
export class ResourceService extends CrudService<IResource, ResourceStore, ResourceQuery> {

  constructor(
    protected store: ResourceStore,
    public query: ResourceQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy,
  ) {
    super(
      Topics.RESOURCES,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

}
